import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';

const TestRoutingPage: React.FC = () => {
    console.log('🧪 TestRoutingPage: Component mounted/rendered');
    
    return (
        <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
            <Paper sx={{ p: 3 }}>
                <Typography variant="h4" gutterBottom>
                    Test Routing Page
                </Typography>
                <Box sx={{ mt: 2 }}>
                    <Typography variant="body1">
                        Se vedi questa pagina, il routing React Router funziona correttamente.
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                        Timestamp: {new Date().toISOString()}
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default TestRoutingPage;